import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import { OctoLink } from "@octopusdeploy/utilities";
import { repository } from "~/clientInstance";
import { RequestFeatureTrialUpsellDialog } from "~/components/UpsellDialog/RequestFeatureTrialUpsellDialog";
import { UpsellAuditStreamIllustration } from "~/components/UpsellDialog/UpsellAuditStreamIllustration";
export function AuditStreamUpsellButton() {
    return (<RequestFeatureTrialUpsellDialog featureName={"Audit Stream"} triggerContent="Stream Audit Log" upsellDialogTitle="Stream audit events to your SIEM for faster detection and easier audits" docsLabel="Docs: Audit Stream" docsLink={OctoLink.Create("AuditStream")} requestTrialDialogTitle="Request a free trial of Audit Stream" onRequestTrial={async () => {
            await repository.AuditStreamConfiguration.requestTrial();
        }} upsellDialogSidePanelImage={<UpsellAuditStreamIllustration />}>
            <div className={styles.dialogContent}>
                <p>
                    Audit logs are most helpful when they’re part of your security workflows. Streaming audit events to Splunk, Sumo Logic, or any OTLP-compatible SIEM helps you catch issues early and demonstrate compliance with less manual effort.
                </p>
                <p>Available on the Enterprise tier.</p>
            </div>
        </RequestFeatureTrialUpsellDialog>);
}
const styles = {
    dialogContent: css({
        display: "flex",
        flexDirection: "column",
        font: text.body.regular.large,
        gap: space[16],
        "& p": {
            margin: 0,
            color: themeTokens.color.text.primary,
        },
    }),
};
